import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import {UserLoginService} from '../services/user-login.service';
import {environment} from '../../../environments/environment';


export const AuthGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => {
    const userLoginService = inject(UserLoginService);
    const router = inject(Router);

    if (window.location.hostname.includes(environment.administratorDomain)) {
        return false;
    }

    if (userLoginService.getIsLoggedIn()) {
        console.info('[AuthGuard] User is logged in, redirecting to home');
        return true;
    }

    console.warn("[AuthGuard] Not logged in, redirecting to login. URL:", state.url);
    router.navigate(['/' + environment.baseAppPath + '/login'], { queryParams: { returnUrl: state.url } }).then();
    return false;
};
